import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "styled-components";
import { useTranslation } from "react-i18next";
import { api } from "../../services/axios";
import Toast from "../../components/Toast";
import {
  Box, Grid, Tooltip, CircularProgress, ListItemIcon, ListItemText,  
  FormControl, Select, MenuItem, InputLabel, Button, Backdrop, Checkbox
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import { BsFileEarmarkMedical  } from "react-icons/bs";
import { shade } from "polished";
import { IconClear } from "../styles";
import { getMonthYear } from "../../utils/helpers";

interface Operation {
  id: number;
  name: string;
};

export default function PontoTxt() {
  const { t } = useTranslation();
  const { colors } = useContext(ThemeContext);
  const [msgModal, setMsgModal] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [mesAno, setMesAno] = useState([]);
  const [monthYear] = useState(getMonthYear("br"));
  const [start, setStart] = useState<Dayjs | null>(dayjs);
  const [end, setEnd] = useState<Dayjs | null>(dayjs);
  const [colaborador, setColaborador] = useState<Operation[]>([]);
  const [colaboradorSelect, setColaboradorSelect] = useState<string[]>([]);
  const isAllColaboradorSelected = colaborador.length > 0 && colaboradorSelect.length === colaborador.length;
  
  const [values, setValues] = useState({
    dataInicial: "",
    dataFinal: "",
    personId: "",
  });

const style = {
    position: "relative",
    width: "100%",
    padding: "40px 10px 10px",
    bgcolor: colors.c01,
    border: '0',
    boxShadow: 0,
    height: '96vh',
    color: colors.c04
  };

  const styleInput = {
    background: 'transparent',
    margin: '10px',
    input: {
      color: colors.c04
    },
    "input:-webkit-autofill, input:-webkit-autofill:focus": {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    '& .MuiSvgIcon-root': {
      color: colors.c04, // Cor do ícone
    },
    '& .MuiPickersDay-root': {
      color: colors.c04, // Cor dos dias
      '&.Mui-selected': {
        backgroundColor: colors.c01, // Fundo do dia selecionado
        color: colors.c04, // Cor do texto do dia selecionado
      },
      '&.Mui-selected:hover': {
        backgroundColor: shade(0.1, colors.c01), // Fundo ao passar o mouse no dia selecionado
      },
    },
    '& .MuiDateCalendar-root': {
      backgroundColor: colors.c01, // Fundo do cabeçalho
    },
    '& .MuiPickersSlideTransition-root .MuiDateRangeCalendar-root': {
      backgroundColor: colors.c01, // Fundo do calendário
    },
    // Root class for the input field
    "& .MuiOutlinedInput-root": {
      background: 'transparent',
      borderColor: colors.c04,
      color: colors.c04,
      '& fieldset': { borderColor: colors.c04 },
      '&:hover fieldset': { borderColor: colors.c04 },
      '&.Mui-focused fieldset': { borderColor: colors.c04 },
      // Class for the border around the input field
      "& .MuiOutlinedInput-notchedOutline": {
        background: 'transparent',
        borderColor: colors.c04,
        borderWidth: "1px",
      },
    },
    // Class for the label of the input field
    "& .MuiInputLabel-outlined": {
      background: 'transparent',
      color: colors.c04
    },
    fieldset: {
      border: 0
    },
    "& label.Mui-focused": {
      background: 'transparent',
      color: colors.c04
    },
    "& .MuiInput-underline:after": {
      background: 'transparent',
      borderBottomColor: colors.c04
    },
  };

  const styleSelect = {
    margin: '2px 0 0 0',
    backgroundColor: colors.c01,
    color: colors.c04, // cor do texto
    '& .MuiSelect-icon': { color: colors.c04 }, // ícone de seta do Select
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.c04, // cor da borda quando não focada
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: shade(0.1, colors.c04), // cor da borda ao passar o mouse
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.c04, // cor da borda ao focar
    }
  };

  const styleMenuSelect = {
    backgroundColor: colors.c01, // Cor de fundo
    color: colors.c04, // Cor do texto
    '&.MuiMenuItem-root': { backgroundColor: colors.c01 },
    '&:hover': {
      backgroundColor: shade(0.1, colors.c01), // Cor ao passar o mouse
      color: colors.c04, // Cor do texto ao passar o mouse
    },
    '&.Mui-selected': {
      backgroundColor: shade(0.2, colors.c01), // Cor do item selecionado
      color: colors.c04, // Cor do texto no item selecionado
    },
    '&.Mui-selected:hover': {
      backgroundColor: colors.c01, // Cor ao passar o mouse no item selecionado
    }
  };

  useEffect(() => {
    getColaborador();
  }, []);

  async function getColaborador() {
    try {
      setMsgModal("Pesquisando, Aguarde!");
      handleOpen();
      clearSearch();
      setColaborador([]);
      const response = await api.get('/person/dimep');
      if (response.status === 200) {
        const { result } = response.data;
        let retColaborador = await result.map((item: any) => {
          return { id: item.id, name: item.name };
        })
        setColaborador(retColaborador);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: response.data.message });
      } else {
        Toast({ type: "error", message: response.data.message });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  };

  useEffect(() => {
    if (colaboradorSelect.length > 0) {
      let idsSearch = "";
      let vir = "";
      colaboradorSelect.map((row) => {
        idsSearch += vir + colaborador.find((element) => element.name === row)?.id.toString();
        vir = ",";
      });
      setValues({ ...values, personId: idsSearch });
    }
  }, [colaboradorSelect]);


  //Gerar TXT
  async function sendTXT() {
    try {
      setMsgModal("Gerando o TXT. Aguarde!");
      handleOpen();
      var obj = {
        dataInicial: values.dataInicial,
        dataFinal: values.dataFinal,
        personId: values.personId === "" ? [] : values.personId.split(",")
      };
      const response = await api.put("/pontotxt", obj);
      if (response.status === 200) {
        const { config } = response;
        const { path } = response.data;
        const url = `${config.baseURL}${path}`;
        const fileResponse = await fetch(url);
        const blob = await fileResponse.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = path; // Nome do arquivo ao baixar
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);

      handleClose();

//        window.open(url, '_blank');
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message: response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

  function clearSearch() {
    setValues({
      ...values,
      dataInicial: "",
      dataFinal: "",
      personId: ""
    });
    setMesAno([]);
    setStart(null);
    setEnd(null);
  };

  const handleMesAno = (item: any) => {
    setMesAno(item.target.value);
    if (item != null) {
      var dtIni = dayjs(monthYear[item.target.value].dtInicial);
      var dtFim = dayjs(monthYear[item.target.value].dtFinal);
      setStart(dtIni);
      setEnd(dtFim);
      setValues({ ...values, dataInicial: dtIni.format('DD/MM/YYYY'), dataFinal: dtFim.format('DD/MM/YYYY') })
    }
  };

  const startDate = (iniValue: any | null) => {
    if (iniValue !== null) {
      setStart(iniValue);
      setValues({ ...values, dataInicial: iniValue.format('DD/MM/YYYY') })
    }
  };

  const endDate = (endValue: any | null) => {
    if (endValue !== null) {
      setEnd(endValue);
      setValues({ ...values, dataFinal: endValue.format('DD/MM/YYYY') })
    }
  };

  const handleChangeColaborador = (event: any) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setColaboradorSelect(colaboradorSelect.length === colaborador.length ? [] : colaborador.map((lin) => lin.name));
      return;
    }
    setColaboradorSelect(value);
  };

  return (
    <Box sx={style}>
      <h4>Relatorio de Horas (TXT)</h4><Box py={1} />
      <Grid container spacing={2} direction="row">
        <Box px={0.5} />
        <FormControl sx={{ m: 0, minWidth: 100, width: '13%', backgroundColor: colors.c01 }} size="small">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={t("locale") === 'br' ? 'pt-br' : t("locale") === 'en' ? 'en-gb' : 'es'}>
            <DesktopDatePicker
              label={t("hours.SdtInic")}
              sx={styleInput}
              value={start}
              onChange={(eventInt) => startDate(eventInt)}
              slotProps={{
                textField: { size: 'small' },
                calendarHeader: { sx: { backgroundColor: colors.c17, color: colors.c04 } },
                previousIconButton: { sx: { color: colors.c04 } },
                nextIconButton: { sx: { color: colors.c04 } },
                day: { sx: { backgroundColor: colors.c01, color: colors.c04 } },
                desktopPaper: { sx: { backgroundColor: colors.c17, color: colors.c04 } }
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl sx={{ m: 0, minWidth: 100, width: '13%', backgroundColor: colors.c01 }} size="small">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={t("locale") === 'br' ? 'pt-br' : t("locale") === 'en' ? 'en-gb' : 'es'} >
            <DesktopDatePicker
              label={t("hours.SdtEnd")}
              sx={styleInput}
              disableHighlightToday={false} // Permite o destaque do hoje
              value={end}
              onChange={(eventEnd) => endDate(eventEnd)}
              slotProps={{
                textField: { size: 'small' },
                calendarHeader: { sx: { backgroundColor: colors.c17, color: colors.c04 } },
                previousIconButton: { sx: { color: colors.c04 } },
                nextIconButton: { sx: { color: colors.c04 } },
                day: { sx: { backgroundColor: colors.c01, color: colors.c04 } },
                desktopPaper: { sx: { backgroundColor: colors.c17, color: colors.c04 } }
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 100, width: '10%', backgroundColor: colors.c01 }} size="small">
          <InputLabel sx={{ color: colors.c04 }} id="month">{t("service.Smonth")}</InputLabel>
          <Select
            sx={styleSelect}
            labelId="month"
            id="month"
            value={mesAno}
            label={t("service.Smonth")}
            onChange={handleMesAno}
          >
            {monthYear.map((row: any, index) => (
              <MenuItem sx={styleMenuSelect} value={row.id}>{row.monthYear}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 100, width: '29%', backgroundColor: colors.c01 }} size="small">
          <InputLabel sx={{ color: colors.c04 }} id="Colaborador">Colaboradores</InputLabel>
          <Select
            sx={styleSelect}
            multiple
            labelId="Colaborador"
            id="Colaborador"
            value={colaboradorSelect}
            label="Colaboradores"
            onChange={handleChangeColaborador}
            renderValue={(colaboradorSelect) => colaboradorSelect.join(", ")}
          >
            {colaborador.length > 0 &&
              <MenuItem value="all" sx={styleMenuSelect}>
                <ListItemIcon>
                  <Checkbox sx={{ color: colors.c04 }}
                    checked={isAllColaboradorSelected}
                    indeterminate={
                      colaboradorSelect.length > 0 && colaboradorSelect.length < colaborador.length
                    }
                  />
                </ListItemIcon>
                <ListItemText
                  primary={t("hours.SelectAll")}
                />
              </MenuItem>
            }
            {colaborador.map((row: any, index) => (
              <MenuItem key={row.name} value={row.name} sx={styleMenuSelect}>
                <Checkbox sx={{ color: colors.c04 }} checked={colaboradorSelect.indexOf(row.name) > -1} />
                <ListItemText primary={row.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box px={1} />
        <Tooltip title={t("hours.txt")} placement="bottom-start" arrow>
          <Button size="small" onClick={() => sendTXT()}
            sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c19, '&:hover': { opacity: 0.7, backgroundColor: colors.c19 } }}
            aria-label={t("hours.txt")}>
            <BsFileEarmarkMedical  size={18} color={colors.c05} />
          </Button>
        </Tooltip>
        <Box px={3} />
        <Tooltip title={t("hours.clean")} placement="bottom-start" arrow>
          <Button size="small" onClick={() => clearSearch()}
            sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13 } }}
            aria-label={t("hours.clean")}>
            <IconClear size={19} color={colors.c05} />
          </Button>
        </Tooltip>
      </Grid>
      <Box sx={{ textAlign: 'center', alignContent: 'center' }}>
        <Backdrop
          sx={(theme) => ({ color: colors.c04, zIndex: theme.zIndex.drawer + 1 })}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
          <Box px={1} />
          {msgModal}
        </Backdrop>
      </Box>
    </Box>
  );
}